import { render, staticRenderFns } from "./AllAlerts.vue?vue&type=template&id=cd0e3dd8&scoped=true&"
import script from "./AllAlerts.vue?vue&type=script&lang=ts&"
export * from "./AllAlerts.vue?vue&type=script&lang=ts&"
import style0 from "./AllAlerts.vue?vue&type=style&index=0&id=cd0e3dd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0e3dd8",
  null
  
)

export default component.exports